import React from 'react'
import {useSelector} from 'react-redux'
import { Fragment} from 'react'
let Footer = function(props){

  let footerText = useSelector(state => state.footerText).trim()
  let formFooterText = useSelector(state => state.formFooterText).trim()

  return (
    <Fragment>
      {formFooterText &&
        <div className="r-form-footer col-sm-12">
          <div className="r-form-footer-text" dangerouslySetInnerHTML={{ __html: formFooterText}}/>
        </div>
      }
      {footerText &&
        <div className="r-footer col-sm-12">
          <div className="r-footer-text" dangerouslySetInnerHTML={{ __html: footerText}}/>
        </div>
      }
    </Fragment>
  )
}
export default Footer;